var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidepassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#909090;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eye-slash-regular",
    className: "cls-1",
    d: "M48.59,41.14,3.66,6A1.21,1.21,0,0,0,2,6.23l-.76.94A1.21,1.21,0,0,0,1.4,8.86L46.34,44A1.21,1.21,0,0,0,48,43.77l.76-.94a1.21,1.21,0,0,0-.19-1.69h0ZM23.25,16.78l10.13,7.91a8.37,8.37,0,0,0-8.66-8.09A7.3,7.3,0,0,0,23.25,16.78Zm3.49,16.44L16.61,25.31A8.39,8.39,0,0,0,25,33.4,8.59,8.59,0,0,0,26.74,33.22ZM25,14.19A20.43,20.43,0,0,1,42.88,25a21.88,21.88,0,0,1-3.31,4.52l2.84,2.21a25.06,25.06,0,0,0,4-5.64,2.42,2.42,0,0,0,0-2.19A24.13,24.13,0,0,0,25,10.58,23.2,23.2,0,0,0,17.13,12l3.49,2.72A19.51,19.51,0,0,1,25,14.19Zm0,21.62A20.45,20.45,0,0,1,7.12,25a21.52,21.52,0,0,1,3.31-4.52L7.59,18.26a25.19,25.19,0,0,0-4,5.64,2.44,2.44,0,0,0,0,2.2A24.11,24.11,0,0,0,25,39.42,23.45,23.45,0,0,0,32.86,38l-3.49-2.73A18.94,18.94,0,0,1,25,35.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidepassword);
export default __webpack_public_path__ + "static/media/hidepassword.71db7d8deb943c3ee78c61e31e94d640.svg";
export { ForwardRef as ReactComponent };